
<template>
    <div class="card" data-aos="fade-right">
      <div class="card-content">
        <span class="card-title txtAppDarkGrey"><strong>Contactez-moi !</strong></span>
        <div class="row">
          <div class="col m6 txtAppDarkGrey">
            <p>Pour savoir si je peux vous <strong>être utile</strong>, le mieux c'est d'en <strong>discuter</strong> !</p>
            <ul>
              <li>Par mail (pour les questions simples)</li>
              <li>Par téléphone</li>
              <li>Par webcam</li>
              <li>Ou même physiquement si vous êtes basé à Lyon</li>
            </ul>
          </div>
          <div class="col m6 txtAppDarkGrey">
            <p><strong>Contactez-moi directement, ou laissez votre mail pour que je vous contacte.</strong></p>
            <p><i class="fas fa-at"></i> pl.despaigne@gmail.com</p>
            <div class="row">
              <div class="col m12 l8 input-field">
                <input type="text" id="customer-email-0" class="validate" required pattern=".+@.+\..+">
                <label for="customer-email-0">Entrez votre adresse e-mail</label>
                <span class="helper-text" data-error="Adresse email non valide" data-success="Ok"></span>
              </div>
              <div class="col m12 l4 pad-top-20">
                <button class="btn waves-effect waves-light cta-btn send-email-btn" type="submit" name="action" data-input="customer-email-0">Envoyez
                  <i class="material-icons right">send</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'sitesection'
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
ul {
  padding-left: 16px;
}
ul > li {
  list-style: square inside;
}
.very-large {
  font-size: 12rem;
}
/* label color */
.input-field label {
  color: #1d263b;
}
/* label focus color */
.input-field input[type=text]:focus + label {
  color: #e84855;
}
.input-field input[type=text] {
  border-bottom: 1px solid #1d263b;
}
/* label underline focus color */
.input-field input[type=email]:focus {
  border-bottom: 1px solid #e84855;
  box-shadow: 0 1px 0 0 #e84855;
}
.pad-top-20 {
  padding-top: 20px;
}
.cta-btn {
    background-color: #e84855;
}
</style>



// WEBPACK FOOTER //
// src/components/Sitesection.vue